import React from 'react';
import { StyleSheet, View } from 'react-native';
import Button from 'shared/components/vxl/Button/Button';
import HairLineDivider from 'shared/components/vxl/divider/HairlineDivider/HairLineDivider';
import { ListItemProps } from 'shared/components/vxl/ListItem/ListItem';
import ListItemGroup from 'shared/components/vxl/ListItemGroup/ListItemGroup';
import { Tag, TagProps } from 'shared/components/vxl/Tag/Tag';
import BodySmText from 'shared/components/vxl/typography/primary/body/BodySmText';
import TitleSmText from 'shared/components/vxl/typography/primary/title/TitleSmText';
import theme from 'shared/styles/theme';

export interface ColumnTaxCardProps {
  headerText: string;
  headerTag: TagProps;
  bodyTitleText: string;
  bodyTitleTrailingText?: string;
  bodyTextTrailingColor?: string;
  bodyDescriptionText?: string;
  rowData: ListItemProps[];
  footerButtonText: string;
  footerButtonAction: () => void;
}

const ColumnTaxCard = ({
  headerText,
  headerTag,
  bodyTitleText,
  bodyTitleTrailingText,
  bodyTextTrailingColor,
  bodyDescriptionText,
  rowData,
  footerButtonText,
  footerButtonAction,
}: ColumnTaxCardProps) => {
  return (
    <View style={styles.container}>
      <View style={styles.titleContainer}>
        <BodySmText numberOfLines={1}>{headerText}</BodySmText>
        <Tag {...headerTag} />
      </View>
      <View style={styles.hairlineDivider}>
        <HairLineDivider />
      </View>
      {!bodyTitleTrailingText ? (
        <View style={styles.contentContainer}>
          <TitleSmText numberOfLines={1}>{bodyTitleText}</TitleSmText>
          <BodySmText numberOfLines={0}>{bodyDescriptionText}</BodySmText>
        </View>
      ) : (
        <View style={styles.contentListContainer}>
          <TitleSmText numberOfLines={1}>{bodyTitleText}</TitleSmText>
          <TitleSmText
            numberOfLines={1}
            style={{
              color: bodyTextTrailingColor,
            }}
          >
            {bodyTitleTrailingText}
          </TitleSmText>
        </View>
      )}
      <ListItemGroup items={rowData} />

      <View style={styles.hairlineDivider}>
        <HairLineDivider />
      </View>
      <View style={styles.buttonContainer}>
        <Button
          type="TEXT"
          label={footerButtonText}
          size="LARGE"
          onPress={footerButtonAction}
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  buttonContainer: { paddingVertical: theme.spacing.s },
  container: {
    backgroundColor: theme.color.background.primary,
    borderRadius: 4,
    width: '100%',
  },
  contentContainer: { padding: theme.spacing.m },
  contentListContainer: {
    flexDirection: 'row',
    gap: theme.spacing.s,
    justifyContent: 'space-between',
    paddingHorizontal: theme.spacing.m,
    paddingTop: theme.spacing.m,
  },
  hairlineDivider: { paddingHorizontal: theme.spacing.m },
  titleContainer: {
    flexDirection: 'row',
    gap: theme.spacing.m,
    justifyContent: 'space-between',
    padding: theme.spacing.m,
  },
});

export default ColumnTaxCard;
